import { DangerouslySetInnerHTML } from 'front-end/src/utils/DangerouslySetInnerHTML'
import React, { FC } from 'react'
import { Box } from 'front-end/src/components'
import { getQuillStyle } from 'front-end/src/components/common/quill/EditorQuill'

const TextElement: FC<{ content: string }> = ({ content }) => {
  return (
    <Box
      data-test="TextElementView"
      css={getQuillStyle('ql-editor')}
      className="ql-editor multimedia-content view"
    >
      <DangerouslySetInnerHTML content={content} />
    </Box>
  )
}

export default TextElement
